export default __webpack_public_path__ + "static/miceBanner2_1440-97514f7b313b3a4861a5d0d2cb076bbe.jpg";